//redux/actions/meals.js
import axios from 'axios';
import { BaseUrl } from '../../server';

export const getAllFeaturedMeals = (page, limit, categoryId, titleAr, titleEn, sortOrder) => async (dispatch) => {
    try {
        // إرسال طلب بدء جلب البيانات
        dispatch({ type: 'get_all_FeaturedMeals_request' });

        // تحضير params object
        const params = {
            page,
            limit,
        };
        
        // إضافة الفلاتر إذا كانت موجودة
        if (categoryId) params.categoryId = categoryId;
        if (titleAr) params.titleAr = titleAr;
        if (titleEn) params.titleEn = titleEn;
        if (sortOrder) params.sortOrder = sortOrder; // إضافة معامل الترتيب

        // إضافة Pagination إلى query parameters
        const { data } = await axios.get(`${BaseUrl}/featuredMeals`, {
            params: params,
        });

        // إرسال البيانات بنجاح مع معلومات Pagination
        dispatch({
            type: 'get_all_FeaturedMeals_success',
            payload: {
                meals: data.featuredMeals,
                pagination: data.pagination,
                totalFeaturedMeals: data.totalFeaturedMeals,
                totalfeaturedMeals: data.totalfeaturedMeals
            },
        });
console.log("data from action",data)
    } catch (error) {
        // إرسال خطأ في حالة فشل الطلب
        dispatch({
            type: "get_all_FeaturedMeals_error",
            payload: error.response?.data?.message || "حدث خطأ ما",
        });
    }
};
export const getFillterFeaturedMeals = (page , limit,categoryId ,titleAr,titleEn,price) => async (dispatch) => {
    try {
        // إرسال طلب بدء جلب البيانات
        dispatch({ type: 'get_Fillter_FeaturedMeals_request' });

        // إضافة Pagination إلى query parameters
        const { data } = await axios.get(`${BaseUrl}/featuredMeals/filter`, {
            params: {
                page,
                limit,
                categoryId,
                titleAr,
                titleEn,
                price
            },
            withCredentials: true,
        } )
    ;

        // إرسال البيانات بنجاح مع معلومات Pagination
        dispatch({
            type: 'get_Fillter_FeaturedMeals_success',
            payload: {
                meals: data.featuredMeals,
                pagination: data.pagination, // معلومات Pagination من الخادم
            },
        });

    } catch (error) {
        // إرسال خطأ في حالة فشل الطلب
        dispatch({
            type: "get_Fillter_FeaturedMeals_error",
            payload: error.response?.data?.message || "حدث خطأ ما",
        });
    }
};
export const getFeaturedMeal = (id) => async (dispatch) => {
    try {
       
        dispatch({ type: 'get_FeaturedMeal_request' });

        const { data } = await axios.get(`${BaseUrl}/featuredMeals/${id}`);
      
        dispatch({ type: 'get_FeaturedMeal_success' ,payload:data.featuredMeal});

    } catch (error) {
        dispatch({
            type: "get_FeaturedMeal_error",
            payload: error.response.data.message,
          });
    }
}
export const createFeaturedMeal= (newForm) => async (dispatch) => {
    try {
        dispatch({ type: 'create_FeaturedMeal_request' });
        const config = { headers: { "Content-Type": "multipart/form-data" } };
        const { data } = await axios.post(`${BaseUrl}/featuredMeals/create`,
           newForm,
           config);

        dispatch({ type: 'create_FeaturedMeal_success', payload: data.featuredMeal });
    } catch (error) {
        dispatch({
            type: "create_FeaturedMeal_error",
            payload: error.response.data.message,
          });
    }
};
// redux/actions/meals.js - إضافة action جديد فقط
export const getFilteredFeaturedMealsWithSort = (page, limit, filters) => async (dispatch) => {
    try {
        dispatch({ type: 'get_FillterWithSort_FeaturedMeals_request' });

        // بناء parameters مع جميع الفلاتر
        const params = {
            page,
            limit,
            categoryId: filters.categoryId || undefined,
            titleAr: filters.search || undefined,
            titleEn: filters.search || undefined,
            priceMin: filters.priceMin || undefined,
            priceMax: filters.priceMax || undefined,
            sortBy: filters.sortBy || 'default'
        };

        const { data } = await axios.get(`${BaseUrl}/featuredMeals/filter-enhanced`, {
            params,
            withCredentials: true,
        });

        dispatch({
            type: 'get_FillterWithSort_FeaturedMeals_success',
            payload: {
                meals: data.featuredMeals,
                pagination: data.pagination,
            },
        });

    } catch (error) {
        dispatch({
            type: "get_FillterWithSort_FeaturedMeals_error",
            payload: error.response?.data?.message || "حدث خطأ ما",
        });
    }
};
export const deleteFeaturedMeal = (id) => async (dispatch) => {
    try {
    
        dispatch({ type: 'delete_FeaturedMeals_request' });

     const {data} =  await axios.delete(`${BaseUrl}/featuredMeals/${id}`);

        dispatch({ type: 'delete_FeaturedMeals_success' ,
    payload: data.message
    });
    } catch (error) {
        dispatch({
            type: "delete_FeaturedMealsl_error",
            payload: error.response.data.message,
          });
    }
};
export const ClearFeaturedMeal = () => async (dispatch) => {    
    dispatch({ type: 'clear_FeaturedMeals' });
}